import { AddCircle } from '@mui/icons-material';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { QuickLinksOrderList } from '~/scenes/MyWorkspace/components/Widgets/components/QuickLinksWidget/components/ConfigureQuickLinksDialogContent/components/QuickLinksOrderList';
import { WorkspaceType } from '~/scenes/MyWorkspace/data';

import { QuickLinkViewItem } from '../../models';

import { useConfigureQuickLinksDialogContent } from './useConfigureQuickLinksDialogContent';
import { useSxStyles } from './useStyles';

export interface ConfigureQuickLinksDialogContentProps {
  quickLinkItems: QuickLinkViewItem[];
  onClose: () => void;
  workspaceType?: WorkspaceType;
}

export const ConfigureQuickLinksDialogContent = (
  props: ConfigureQuickLinksDialogContentProps,
) => {
  const { onClose, workspaceType } = props;

  const sxStyles = useSxStyles();
  const { t } = useTranslation();
  const { handleSave, addNewLink, control, quickLinksFieldArray } =
    useConfigureQuickLinksDialogContent(props);

  const isCompanyWorkspace = workspaceType === WorkspaceType.Company;

  return (
    <Box sx={sxStyles.form}>
      <DialogTitle sx={sxStyles.dialogTitleRoot}>
        <Box sx={sxStyles.dialogTitleContent}>
          {t('myQuickLinks')}
          {!isCompanyWorkspace && (
            <IconButton
              color="primary"
              onClick={addNewLink}
              data-cy="add"
              size="large"
            >
              <AddCircle />
            </IconButton>
          )}
        </Box>
      </DialogTitle>
      <DialogContent sx={sxStyles.dialogContent}>
        <QuickLinksOrderList
          control={control}
          quickLinksFieldArray={quickLinksFieldArray}
          workspaceType={workspaceType}
        />
      </DialogContent>
      <DialogActions>
        <Button data-id="cancel" color="primary" onClick={onClose}>
          {t('cancel')}
        </Button>
        {!isCompanyWorkspace && (
          <Button
            data-id="save"
            variant="contained"
            color="primary"
            data-cy="save"
            onClick={handleSave}
          >
            {t('save')}
          </Button>
        )}
      </DialogActions>
    </Box>
  );
};
